module.exports = __webpack_public_path__ + "img/car-1.e756b300.svg";